import Notify from '@shared/notify';
import APIService from '@shared/services/api';
import React, { useEffect, useState } from 'react';
import { Button, Modal, Table, Form } from 'react-bootstrap';

export default function BidModel(props: any) {
    const [bids, setBids] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [isEdit, setIsEdit] = useState(false);
    const [bidId, setBidId] = useState('');
    const [editedAmount, setEditedAmount] = useState<number | null>(null);  // Local state for edited amount
    const [selectedBidId, setSelectedBidId] = useState<number | null>(null);  // To track the bid being edited

    useEffect(() => {
        getBids();
    }, []);

    const getBids = async () => {
        try {

            setLoading(true);
            const url = `bid/demand/${props?.demandId}`;
            const apiResp = await APIService.getAll(url, true, false);

            if (apiResp) {
                const bidList = apiResp?.data?.data?.bids.filter((item) => item.status == 'notSelected');
                if (bidList.length > 0) {
                    const result = bidList.sort((a: any, b: any) => a.rate - b.rate);
                    const minAmount = result.length > 0 ? result[0].rate : null;
                    const finalResult = result.filter((item: any) => item.rate == minAmount);

                    setBids(finalResult || []);
                }
            }
        } catch (err) {
            setError('Failed to fetch bids');
        } finally {
            setLoading(false);
        }
    };

    const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        setEditedAmount(e.target.value);
    };

    const saveEditedAmount = async (bid: any, newRate: number) => {

        if (!newRate) {
            Notify('error', 'Please enter amount');
            return false;
        }

        if (newRate >= bid?.rate) {
            Notify('error', 'New bid rate cannot be higher than or equal to the existing bid rate.');
            return false;
        } else {

            const data = {
                newRate: newRate
            }
            const apiResp = await APIService.update(`bid/rate`, bid.id, data, true, false);

            if (apiResp.status === 200) {
                Notify('success', 'Rate  updated successfully');
                props.handleModal(false);
                cancelEdit()

            }
        }

    }


    const cancelEdit = () => {
        setIsEdit(false);  // Close the editing mode without saving
        setEditedAmount(null);  // Reset the edited amount state
    };

    return (
        <Modal
            scrollable={true}
            show={true}
            onHide={() => {
                try {
                    props.handleModal(false);
                } catch (error) {
                    console.error(error);
                }
            }}
            backdrop="static"

            keyboard={false}
            size={'xl'}
        >
            <Modal.Header closeButton>
                <Modal.Title>{`Demand id : ${props?.demandId}`}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {loading && <p>Loading bids...</p>}
                {error && <p style={{ color: 'red' }}>{error}</p>}

                {!loading && !error && bids.length > 0 && (
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Bid ID</th>
                                <th>Name</th>
                                <th>Number</th>
                                <th>Amount</th>
                                <th>New Amount</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bids.map((bid: any) => (
                                <tr key={bid.id}>
                                    <td>{bid.id}</td>
                                    <td>{bid.app_user.name}</td>
                                    <td>{bid.app_user.phone}</td>
                                    <td>
                                        {
                                            bid.rate
                                        }

                                    </td>
                                    <td className='removeInputNumber'>
                                        {isEdit && selectedBidId === bid.id && (
                                            <Form.Control
                                                type="number"
                                                value={editedAmount !== null ? editedAmount : bid.amount}
                                                onChange={handleAmountChange}
                                            />
                                        )}
                                    </td>

                                    <td>
                                        <span className={`badge ${bid.status === 'notSelected' ? 'bg-warning text-dark' :
                                            'bg-secondary'
                                            }`}>
                                            {bid.status == 'notSelected' ? 'Not Selected' : bid.status}
                                        </span>
                                    </td>
                                    <td>
                                        {isEdit && selectedBidId === bid.id ? (
                                            <>
                                                <Button onClick={() => saveEditedAmount(bid, editedAmount)} className="mr-2">
                                                    Save
                                                </Button>
                                                <Button onClick={cancelEdit} className="ml-2" style={{ marginLeft: "4px" }}>
                                                    Cancel
                                                </Button>
                                            </>
                                        ) : (
                                            <Button onClick={() => {
                                                setIsEdit(true);
                                                setSelectedBidId(bid.id);
                                                setEditedAmount(bid.amount);  // Pre-fill the input with the current amount
                                            }}>Edit</Button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}

                {!loading && !error && bids.length === 0 && <p>No bids available</p>}
            </Modal.Body>

            <Modal.Footer>
                <button onClick={() => props.handleModal(false)} className="btn btn-secondary">
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    );
}
